export const HEADERS = [
	'No.',
	'Type',
	'Status',
	'Consultant',
	'Created at',
	'Talking time',
	'Actions',
];
